<div class="row">
  <div class="col-12 action-container">
    <button
      id="progress-bar"
      [style.width]="width"
      [style.height]="height"
      [style.margin]="margin"
      class="btn btn-sm btn-primary loading-button action-button primary-btn-theme"
      [ngClass]="progressBarShown ? 'progress-bar-progress' : ''"
      (click)="performAction($event)"
      [disabled]="progressBarShown || disabledCondition || isImpersonated"
    >
      <div [ngStyle]="{ width: progressValue }" class="progress"></div>
      <div id="content" class="content">
        {{ buttonText }}
      </div>
    </button>
  </div>
</div>
